import addNamespaces from '../../translations/add-namespaces';
import unitControlEn from '../../translations/unitControl/en.json';
import unitControlNl from '../../translations/unitControl/nl.json';

addNamespaces('unitControl', { en: unitControlEn, nl: unitControlNl });

export default undefined;
